import React from "react";
import LegalPageShell, { Section } from "./LegalPageShell";

export default function TermsConditions() {
  return (
    <LegalPageShell eyebrow="Legal" title="Terms & Conditions" updated="February 2026">
      <p>
        These terms govern your use of <strong>newdaystays.in</strong> (the &quot;Website&quot;) and any bookings
        made with NewDayStays Hospitality (&quot;we&quot;, &quot;us&quot;, &quot;NewDayStays&quot;). By using this
        website or making a booking, you agree to these terms.
      </p>

      <Section title="1. About us">
        <ul className="list-disc pl-6 space-y-2">
          <li>Business name: <strong>NewDayStays Hospitality</strong></li>
          <li>Operating locations: Goa & Bangalore, India</li>
          <li>Contact: newdaystay@gmail.com · +91 63607 34483</li>
        </ul>
      </Section>

      <Section title="2. Booking process">
        <ul className="list-disc pl-6 space-y-2">
          <li>A booking is confirmed only after full payment is received and you have received a confirmation email/ID.</li>
          <li>All rates are quoted in Indian Rupees (INR) and include 12% GST unless stated otherwise.</li>
          <li>You must be at least 18 years old to make a booking.</li>
          <li>The lead guest is responsible for the conduct of all other guests in the booking.</li>
        </ul>
      </Section>

      <Section title="3. Check-in & ID proof">
        <ul className="list-disc pl-6 space-y-2">
          <li>Standard check-in: <strong>2:00 PM</strong>. Standard check-out: <strong>11:00 AM</strong>.</li>
          <li>All adult guests must present a valid government-issued photo ID at check-in (Aadhaar, Passport, Driving Licence, or Voter ID).</li>
          <li>Foreign nationals must present a valid passport and visa. We are required to file a Form C with FRRO for foreign guests.</li>
          <li>Local IDs from within the same state may be refused at some properties — please confirm with us before booking.</li>
        </ul>
      </Section>

      <Section title="4. Payment terms">
        <ul className="list-disc pl-6 space-y-2">
          <li>All payments are processed securely by <strong>Razorpay</strong>. We do not store your card or UPI details.</li>
          <li>You will receive a GST invoice by email within 24 hours of payment.</li>
          <li>Long-stay bookings (14+ nights) may be offered on 50% advance + 50% at check-in, subject to prior agreement.</li>
        </ul>
      </Section>

      <Section title="5. House rules">
        <ul className="list-disc pl-6 space-y-2">
          <li>No smoking indoors. Designated smoking areas are provided at each property.</li>
          <li>Events, parties, or gatherings exceeding the booked guest count require prior written approval and may attract additional charges.</li>
          <li>Pets are allowed only at pet-friendly properties, which is noted on the listing.</li>
          <li>Please respect quiet hours from 10:00 PM to 8:00 AM out of consideration for neighbours.</li>
          <li>Illegal activities of any kind will result in immediate eviction without refund and may be reported to local authorities.</li>
        </ul>
      </Section>

      <Section title="6. Damages & liability">
        <ul className="list-disc pl-6 space-y-2">
          <li>Guests are liable for any damage, loss, or breakage caused during the stay. Charges will be assessed at the actual repair or replacement cost.</li>
          <li>NewDayStays is not liable for loss, theft, or damage of personal belongings. Guests are advised to secure valuables in the safe (where provided).</li>
          <li>Our maximum liability for any claim arising from your booking is limited to the total amount paid for that booking.</li>
        </ul>
      </Section>

      <Section title="7. Cancellations & refunds">
        <p>
          Cancellation and refund terms are governed by our <a href="/cancellation-policy" className="underline">Cancellation & Refund Policy</a>, which forms part of these Terms.
        </p>
      </Section>

      <Section title="8. Services & delivery">
        <p>
          NewDayStays provides short-term accommodation services. Access to the booked property is granted from the
          check-in time on the arrival date to the check-out time on the departure date, as specified in your booking
          confirmation. No physical goods are shipped; the &quot;service delivery&quot; is your stay at the property.
        </p>
      </Section>

      <Section title="9. Force majeure">
        <p>
          NewDayStays is not liable for failure to perform obligations due to events beyond our reasonable control,
          including natural disasters, government orders, pandemics, strikes, or infrastructure failures.
        </p>
      </Section>

      <Section title="10. Intellectual property">
        <p>
          All content on newdaystays.in — including photography, text, logos, and design — is the property of
          NewDayStays Hospitality or its licensors. You may not reproduce, distribute, or use it commercially
          without written permission.
        </p>
      </Section>

      <Section title="11. Governing law & jurisdiction">
        <p>
          These Terms are governed by the laws of India. Any dispute arising from or in connection with these
          Terms shall be subject to the exclusive jurisdiction of the courts in <strong>Bangalore, Karnataka</strong>.
        </p>
      </Section>

      <Section title="12. Changes to these terms">
        <p>
          We may update these Terms from time to time. The updated version will be posted on this page with a new
          &quot;Last updated&quot; date. Continued use of the website constitutes acceptance of the updated terms.
        </p>
      </Section>
    </LegalPageShell>
  );
}
